const persons = [
  {
    original: 'https://res.cloudinary.com/emilbruckner/image/upload/c_fill,g_face,h_1500,w_850/das-project-foto-alex1_optkpu',
    path: '/alex/',
    name: 'Alex',
    color: 'blue',
    yOffset: 170
  },
  {
    original: 'https://res.cloudinary.com/emilbruckner/image/upload/c_fill,g_face,h_1500,w_850/das-project-foto-florim1_ub5x7z',
    path: '/flo/',
    name: 'Flo',
    color: 'orange',
    yOffset: 20
  },
  {
    original: 'https://res.cloudinary.com/emilbruckner/image/upload/c_fill,g_face,h_1500,w_850/das-project-foto-matthias6_bawmuy',
    path: '/matthias/',
    name: 'Matthias',
    color: 'red',
    yOffset: 130
  },
  {
    original: 'https://res.cloudinary.com/emilbruckner/image/upload/c_fill,g_face,h_1500,w_850/das-project-foto-felix1_zgaub6',
    path: '/felix/',
    name: 'Felix',
    color: 'hotpink',
    yOffset: 300
  },
  {
    original: 'https://res.cloudinary.com/emilbruckner/image/upload/c_fill,g_face,h_1500,w_850/das-project-foto-lisa10_ggusfj',
    path: '/lisa/',
    name: 'Lisa',
    color: 'cornflowerblue',
    yOffset: 190
  },
  {
    original: 'https://res.cloudinary.com/emilbruckner/image/upload/c_fill,g_face,h_1500,w_850/dasproject-foto-band-31_mszmun',
    path: '/band/',
    name: 'Band',
    color: 'green',
    yOffset: 70
  },
  {
    original: 'https://res.cloudinary.com/emilbruckner/image/upload/c_fill,g_face,h_1500,w_850/dasproject-foto-bassam-02_d0u9cs',
    path: '/bassam/',
    name: 'Bassam',
    color: 'yellow',
    yOffset: 300
  },
  {
    original: 'https://res.cloudinary.com/emilbruckner/image/upload/c_fill,g_face,h_1500,w_850/dasproject-foto-niklas-08_r6xlbz',
    path: '/niklas/',
    name: 'Niklas',
    color: 'purple',
    yOffset: 130
  },
  {
    original: 'https://res.cloudinary.com/emilbruckner/image/upload/c_fill,g_face,h_1500,w_850/dasproject-foto-tini-04_ymu8uy',
    path: '/tini/',
    name: 'Tini',
    color: 'coral',
    yOffset: 180
  }
]

export default persons



// WEBPACK FOOTER //
// ../persons.js